export const HOME_PAGE_CONTENT = 'home_page_content'
export const FETCH_REPORTEE = 'fetch_reportee'
export const LAST_FEWS_DAYS_INACTIVE_ACCOUNT = 'last_fews_days_inactive_accounts'
export const FILTER = 'filter'